import React from 'react';
import { componentService } from 'js/services/component.service';

export const GamesSearchButton = React.lazy(() => import(/* webpackChunkName: "games-search-button" */ './GamesSearchButton'));

// <hub2-games-search-button></hub2-games-search-button>
componentService.registerWebContentComponents({ GamesSearchButton });
